import React, { useState, useEffect } from 'react'
import axios from 'axios'

import brasao from '../../assets/brasilNav.png'

const Instrutor = () => {
    const id = window.location.pathname.slice(17)
    const [processo, setProcesso] = useState({ dataCriacao: '' })
    const [membros, setMembros] = useState([])
    const [dados, setDados] = useState({
        id: id, dateI: new Date().toLocaleString(), ano: new Date().toLocaleString().slice(6,10), 
        dataConvert: new Date(), userCreateI: localStorage.nomeE, portaria: '', instrutor: ''
    })

    useEffect(() => {
        const url = `/api/ped/getPed/${id}`
        axios(url)
            .then(res => {
                setProcesso(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    useEffect(() => {
        const url = `/api/userEtica/getMembros/`
        axios(url)
            .then(res => {
                setMembros(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    //Desabilitado, por enquanto...
    // useEffect(() => {
    //     const url = `/api/ped/getPortNumber/`
    //     axios(url)
    //         .then(res => {
    //             setDados(prevState => ({
    //                 ...prevState,
    //                 portaria: res.data.portaria
    //             }))
    //         })
    //         .then()
    //         .catch(error => {
    //             alert(error.response.data)
    //         })
    // }, [])

    const updateField = (e) => {
        const { name, value } = e.target
        setDados(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    const save = (e) => {
        const url = `/api/ped/instrutor/`
        axios.post(url, dados)
            .then(res => {
                alert(res.data)
                window.location = `/etica/documentosPed/${id}`
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }

    return (
        <React.Fragment>
            <div className="capaPedCaixaBranca">
                <img src={brasao} alt="Brasil" className='brasaoPed' />
                <div className='conselho'>CONSELHO REGIONAL DE FISIOTERAPIA E TERAPIA OCUPACIONAL DA 1ª REGIÃO</div>
                <div className="capaPedCaixaVerde">PROCESSO ÉTICO DISCIPLINAR</div>
                <div className="capaPedCaixaVerdeNumero">PED Nº {processo.numeroPed}</div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representante</span>
                    <div className="capaPedElement">{processo.representante}</div>
                    <div className="capaPedElement">{processo.numeroPaf}</div>
                </div>
                <div className="capaPedCaixaVerdeRepresentante">
                    <span className="capaPedRepresentante">Representado</span>
                    <div className="capaPedElement">{processo.representado}</div>
                    <div className="capaPedElement">{processo.numeroCrefito}</div>
                </div>
                <div className="capaPedCaixaVerdeInfracoes">
                    <div className="relatorRevisorMeio">
                        <span className="spanRelatorRevisor">Portaria Nº</span>
                        <input type="number" name="portaria" className="relatorRevisor"
                            // disabled
                            // value={dados.portaria}
                            onChange={e => updateField(e)} />
                    </div>
                    <div className="relatorRevisorMeio">
                        <span className="spanRelatorRevisor">Instrutor</span>
                        <select name="instrutor" className="relatorRevisor"
                            onChange={e => updateField(e)} >
                            <option value=""></option>
                            {selectMembros()}
                        </select>
                    </div>
                </div>
            </div>
            <button className="botaoNPed" onClick={e => save(e)}>ENVIAR</button>
        </React.Fragment>
    )

    function selectMembros() {
        let select = []
        membros.map(x => {
            select.push(
                <option key={x.nome} value={x.nome}>{x.nome}</option>
            )
        })
        return select
    }
}

export default Instrutor